import React from "react";
import './signupnew.css';
import Footer from '../common/footer/footer';
import Header from './../common/header/header';
import Validate from '../common/validate';
import Axios from 'axios';
import { API_HOST, axiosRequest, axiosRequestWithAuth } from './../../constants/server.constant';
import ReCAPTCHA from "react-google-recaptcha";
import ReactTooltip from 'react-tooltip';
import CommonMessage from './../common/commonMessage';
import SessionService from '../../services/session.service';
import $ from 'jquery';
import { userService } from './../../services/user.service';
import { getCookieValueByName, removeCookieValueByName, toQuery } from "../../utility/utility";
import { GoogleLogin } from 'react-google-login';
import { Redirect } from 'react-router-dom';
import { loginService } from "../../services/login.service";
import PopupWindow from "../login/popupWindow";


export class Signupnew extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            email: "",
            password: "",
            isPasswordShown: false,
            emailExists: false,
            emailValidation: false,
            emailEmpty: false,
            passwordValidation: false,
            passwordEmpty: false,
            passwordStrength: "",
            domainError: false,
            isMsgShow: false,
            redirectToIndex: false,
            redirect: "",
            computeCodeVal: ""
        };
        this.emailFocus = React.createRef();
        this.passwordFocus = React.createRef();
        this.recaptchaRef = React.createRef();
        this.validate = this.validate.bind(this);
        this.getFocus = this.getFocus.bind(this);
        this.submit = this.submit.bind(this);
        this.handleInputs = this.handleInputs.bind(this);

    }
    componentDidMount() {
        window.location.href = "https://www.idrive.com/idrive/signup";

        // document.title = "IDrive® Compute | Sign-up page";

        // this.checkEntry();
        // var compute_tag_Val = getCookieValueByName('compute_tag');
        // if(compute_tag_Val) {
        //     let firstChar = compute_tag_Val.charAt(0);
        //     if(firstChar === 'P') this.setState({ computeTagCkVal: compute_tag_Val });
        //     if(firstChar === 'C') this.setState({ computeCodeVal: compute_tag_Val });
        // }
    }
    checkEntry = () => {
        this.setState({
            isAction: true
        });
        userService.checkEntry().then(resp => {
            if(resp === false) {
                this.setState({
                    message: "Error while trying to connect",
                    isAction: false
                });
                return;
            }
            if(resp.data.body === "HIDE_MESSAGE") {
                this.setState({
                    isMsgShow: false,
                    isAction: false
                });
            }
            if(resp.data.body === "SHOW_MESSAGE") {
                this.setState({
                    isMsgShow: true,
                    isAction: false
                });
            }

        }).catch(err => {
            this.setState({
                message: "Error while trying to connect",
                isAction: false
            });
            return;
        });
    };
    getFocus = () => {
        if(this.state.email.length <= 0) {
            this.setState({ emailEmpty: true });
        }
        else {
            this.setState({ emailEmpty: false });
        }

    };
    handleInputs = (event) => {
        let name = event.target.name;
        let val = event.target.value;
        this.setState({
            [name]: val
        });

        if(name === "email") {
            if(val.length <= 0) {
                this.setState({
                    emailEmpty: true,
                    emailExists: false,
                    emailValidation: false,
                    domainError: false
                });
            }
            else {
                this.setState({
                    emailEmpty: false,
                    emailExists: false,
                    emailValidation: false,
                    domainError: false
                });

            }
        }
        if(name === "password") {
            if(val.length <= 0) {
                this.setState({
                    passwordEmpty: true,
                    passwordValidation: false,
                    passwordStrength: ""
                });
            }
            else {
                this.setState({
                    passwordEmpty: false,
                    passwordValidation: false
                });
                const passwordRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[-_+=(){}!@#/$%^&*.:;'\"])(?=\\S+$)(?=.{8,})");
                if(passwordRegex.test(val)) {
                    this.setState({
                        passwordStrength: "Strong"
                    });
                }
                else {
                    this.setState({
                        passwordStrength: "Weak"
                    });
                }
            }

            var upCasePatt = new RegExp("[A-Z]");
            if(upCasePatt.test(val)) {
                $('#upperCaseLi').addClass("success");
            } else {
                $('#upperCaseLi').removeClass("success");
            }
            var lowCasePatt = new RegExp("[a-z]");
            if(lowCasePatt.test(val)) {
                $('#lowerCaseLi').addClass("success");
            } else {
                $('#lowerCaseLi').removeClass("success");
            }
            var numericPatt = new RegExp("[0-9]");
            if(numericPatt.test(val)) {
                $('#numericLi').addClass("success");
            } else {
                $('#numericLi').removeClass("success");
            }
            var specCharPat = /[`!@#$%^&*()_+\-={};':"|,.<>/?~]/;

            if(specCharPat.test(val)) {
                $('#specCharLi').addClass("success");
            } else {
                $('#specCharLi').removeClass("success");
            }

            if(val.length >= 8) {
                $('#eightCharLi').addClass("success");
            } else {
                $('#eightCharLi').removeClass("success");
            }
        }
    };
    onRecaptchaChange = (event) => {
        if(this.state.captchaType == "create")
            this.createUser(event);
        else {
            this.doAutoLogin(event);
        }
    };

    doAutoLogin = (event, email, tokenId, githubCode) => {
        let authUrl, reqObj;
        authUrl = API_HOST + '/login/thirdPartyAuthenticate';
        if(githubCode) {
            reqObj = JSON.stringify({
                email: email,
                password: '',
                rememberMe: false,
                githubCode: tokenId,
            });
        } else if(tokenId) {
            reqObj = JSON.stringify({
                email: email,
                password: '',
                rememberMe: false,
                googleAuthToken: tokenId,
            });
        } else {
            authUrl = API_HOST + '/login/authenticate?captcha=' + event;
            reqObj = JSON.stringify({
                email: this.state.email,
                password: this.state.password,
                rememberMe: false,
            });
        }
        Axios.post(authUrl, reqObj, axiosRequestWithAuth).then(authResp => {
            if(!authResp.data?.error) {
                userService.getUserData().then((response) => {
                    if(response.data.emailVerify !== 1 && response.data.role.id == 2) {
                        localStorage.setItem("_email_verify", response.data.email);
                    }
                    else {
                        localStorage.removeItem("_email_verify");
                    }
                    loginService.setUserLocal(response, true);
                    loginService.executeGoogleScript();
                    SessionService.removeCookie("compute_tag");
                    this.setState({ redirect: authResp.data?.redirect });
                }).catch((error) => {
                    this.setState({
                        wrongcreds: true,
                        errmsg: "Error While trying to connect",
                        isAction: false
                    });
                    if(this.recaptchaRef.current) {
                        this.recaptchaRef.current.reset();
                    }
                });
            }
            else {
                this.setState({
                    wrongcreds: true,
                    errmsg: "Error while fetching Details, try again!",
                    isAction: false
                });
                if(this.recaptchaRef.current) {
                    this.recaptchaRef.current.reset();
                }
            }
        }).catch((err) => {
            this.setState({
                message: "Error while fetching Details, try again!",
                isAction: false
            });
            if(this.recaptchaRef.current) {
                this.recaptchaRef.current.reset();
            }
            return;
        });
    };

    createUser = (event) => {
        this.setState({
            isAction: true
        });
        Axios.post(API_HOST + '/user/create?captcha=' + event,
            JSON.stringify({
                email: this.state.email.trim(),
                password: this.state.password,
                partnerToken: this.state.computeTagCkVal,
                referralCode: this.state.computeCodeVal
            })
            , axiosRequest).then(
                (response) => {
                    //console.log(response)
                    if(response.data.body.error) {
                        if(response.data.body.message === "TIME_OUT") {
                            this.setState({
                                emailExists: false,
                                emailEmpty: false,
                                emailValidation: false,
                                isAction: false,
                                domainError: false,
                                message: "There was some problem during email verification. Please try again.",
                                msgType: "error"
                            });
                            this.emailFocus.current.focus();
                            if(this.recaptchaRef.current) {
                                this.recaptchaRef.current.reset();
                            }
                            return;
                        }
                        if(response.data.body.message === "INVALID_DOMAIN") {
                            this.setState({
                                emailExists: false,
                                emailEmpty: false,
                                emailValidation: false,
                                isAction: false,
                                domainError: true
                            });
                            this.emailFocus.current.focus();
                            if(this.recaptchaRef.current) {
                                this.recaptchaRef.current.reset();
                            }
                            return;
                        }
                        if(response.data.body.message === "VALIDATION_ERROR") {
                            this.setState({
                                emailExists: false,
                                emailEmpty: false,
                                emailValidation: true,
                                isAction: false,
                                domainError: false
                            });
                            this.emailFocus.current.focus();
                            if(this.recaptchaRef.current) {
                                this.recaptchaRef.current.reset();
                            }
                            return;
                        }
                        if(response.data.body.message === "EMAIL_EXISTS") {
                            this.setState({
                                emailExists: true,
                                emailEmpty: false,
                                emailValidation: false,
                                isAction: false,
                                domainError: false
                            });
                            this.emailFocus.current.focus();
                            if(this.recaptchaRef.current) {
                                this.recaptchaRef.current.reset();
                            }
                            return;
                        }

                    }
                    if(!response.data.body.error) {
                        try {
                            removeCookieValueByName('compute_tag');
                        } catch(err) {
                            console.log(err);
                        }
                        this.setState({
                            captchaType: "login"
                        }, () => this.recaptchaRef.current.execute());
                    }
                    else {
                        this.setState({
                            message: "Error while fetching Details, try again!",
                            isAction: false
                        });
                        if(this.recaptchaRef.current) {
                            this.recaptchaRef.current.reset();
                        }

                    }
                }
            ).catch((error) => {
                this.setState({
                    message: "Error while creating user",
                    isAction: false
                });
                if(this.recaptchaRef.current) {
                    this.recaptchaRef.current.reset();
                }
            });
    };

    submit = (event) => {
        event.preventDefault();

        if(this.state.password.length <= 0) {
            this.setState({
                passwordEmpty: true,
                passwordValidation: false
            });
            this.passwordFocus.current.focus();

        }
        if(this.state.email.length <= 0) {
            this.setState({
                emailEmpty: true,
                emailExists: false,
                emailValidation: false,
                domainError: false
            });
            this.emailFocus.current.focus();

        }
        if(this.state.password.length > 0 && this.state.email.length > 0 && this.validate()) {
            this.setState({
                captchaType: "create"
            }, () => this.recaptchaRef.current.execute());

        }

    };

    validate = () => {
        if(!this.state.email) {
            this.setState({
                emailEmpty: true,
                emailExists: false,
                emailValidation: false,
                domainError: false
            });
            this.emailFocus.current.focus();
            return false;
        }
        else if(!Validate("email", this.state.email)) {

            this.setState({
                emailEmpty: false,
                emailExists: false,
                emailValidation: true,
                domainError: false
            });
            this.emailFocus.current.focus();
            return false;
        }
        else if(!Validate("password", this.state.password)) {
            this.setState({
                passwordValidation: true,
                passwordEmpty: false
            });
            this.passwordFocus.current.focus();
            return false;
        }
        return true;
    };

    userNameBlur = () => {
        // if(!this.state.email){
        //     console.log("called null")
        //     this.setState({
        //         emailEmpty:true,
        //         emailExists:false,
        //         emailValidation:false,
        //         domainError:false
        //     })
        // }
        if(this.state.email && !Validate("email", this.state.email)) {
            this.setState({
                emailEmpty: false,
                emailExists: false,
                emailValidation: true,
                domainError: false
            });
        }
    };


    createNewAccount(email, firstName, lastName, fullName, token, googleId) {
        Axios.post(API_HOST + "/user/create/google",
            {
                email: email,
                fName: firstName,
                lName: lastName,
                name: fullName,
                tokenId: token,
                sourceUserId: googleId
            }, axiosRequest).then(resp => {

                if(resp && resp.data) {
                    if(resp.data === "CANCELED_USER") {
                        this.setState({
                            message: "Email: " + email + " already exists",
                            isAction: false
                        });
                    }
                    else if(resp.data == "DB_ERROR" || resp.data == "INVALID_TOKEN" || resp.data == "INVALID_MAIL" || resp.data === "NULL_TOKEN" || resp.data === "ERROR") {
                        this.setState({
                            message: "Error while creating user",
                            isAction: false
                        });
                    }
                    else if(resp.data == "INVALID_DOMAIN") {
                        this.setState({
                            message: "Email address is invalid",
                            isAction: false
                        });
                    }
                    else {
                        if(googleId === null || googleId === undefined) {
                            this.doAutoLogin('', email, token, true);
                        } else {
                            this.doAutoLogin('', email, token);
                        }
                    }
                }
                else {
                    this.setState({
                        message: "Error while creating user",
                        isAction: false
                    });
                }
            }).catch(err => {
                console.log(err);
                this.setState({
                    message: "Error while creating user",
                    isAction: false
                });
            });
    }

    handleGoogleSignUpSuccess(response) {
        if(response && response.profileObj && response.profileObj.email) {
            this.setState({
                isAction: true
            }, function () {
                this.createNewAccount(response.profileObj.email, response.profileObj.givenName, response.profileObj.familyName, response.profileObj.name, response.tokenId, response.googleId);
            });
            //response.profileObj.givenName, response.profileObj.familyName, response.profileObj.name
            //this.createNewAccount(response.profileObj.email, response.profileObj.givenName, response.profileObj.familyName, response.profileObj.name, response.tokenId) ;
        }
    }

    handleGoogleSignUpFailure(response) {
        console.log(response);
        // this.setState({
        //     emailEmpty: false,
        //     emailValidation: false,
        //     emailExists: false,
        //     domainError: false,
        //     passwordEmpty: false,
        //     passwordValidation: false    
        // })
    }

    resetToDefault() {
        this.setState({
            email: "",
            password: "",
            isPasswordShown: false,
            emailExists: false,
            emailValidation: false,
            emailEmpty: false,
            passwordValidation: false,
            passwordEmpty: false,
            passwordStrength: "",
            domainError: false,
            isMsgShow: false,
            redirectToIndex: false
        });
    }

    onGithubBtnClick = (e) => {
        const search = toQuery({
            client_id: "c4fbf9ea5a443ab9b27a",
            scope: "user:email",
            redirect_uri: "https://www.idrivecompute.com/app/login/oauth2/code/github",
        });
        console.log(`https://github.com/login/oauth/authorize?${ search }`);
        const popup = this.popup = PopupWindow.open(
            'github-oauth-authorize',
            `https://github.com/login/oauth/authorize?${ search }`,
            { height: 1000, width: 600 }
        );

        //this.onRequest();
        popup.then(

            data => {
                this.sucessResponseGithub(data); console.log("data " + data.code);
            },
            error => this.errorResponseGithub(error)
        );
    };

    sucessResponseGithub = (res) => {
        if(!res.code) {
            return null;
            //return this.onFailure(new Error('\'code\' not found'));
        }
        this.setState({
            isAction: true
        });
        const axiosHeaders = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            }
        };
        Axios.post(API_HOST + "/login/authenticate/github/user-details", { "gitCode": res.code }, axiosHeaders)
            .then(resp => {
                this.setState({
                    isAction: true
                }, function () {
                    this.createNewAccount(resp.data, '', '', '', res.code, null);
                });
                //this.doAuthentication('','',resp.data,res.code)
            })
            .catch(err => console.log(err));

        // this.setState({isUsernameError:false})
        // if(response && response.profileObj && response.profileObj.email) {
        //     this.doAuthentication('',response.tokenId,response.profileObj.email);
        // }
    };

    errorResponseGithub = (response) => {
        console.log(response);
    };


    triggerClick = (name) => {
        if(name === 'google') $('#googleBtn').trigger('click');
        if(name === 'github') $('#githubBtn').trigger('click');
    };
    render() {
        sessionStorage.signupLoaded = true;
        if(SessionService.getCookie("isLoggedIn") && this.state.redirect !== ``) {
            return <Redirect to={ this.state.redirect } replace={ true }></Redirect>;
        }
        return (
            <main>
                <Header />
                <div className="full_page_loader" style={ { display: this.state.isAction ? 'block' : 'none' } }>
                    <div className="loader_icon"></div>
                </div>
                <div className="static signupPage">

                    <div id="static_form_wrap" className="githubWrap">
                        <div className="sign_in_bg"></div>
                        <div className="wrapper">
                            <div className="box_center_align box_fifty">
                                <form id="signin-form" onSubmit={ (e) => this.submit(e) }>
                                    <div className="box_header_text">
                                        <h1>Create Account</h1>
                                    </div>
                                    <div className="inp_row form_info">
                                        <div className="info">Deploy high-speed NVMe Linux servers for enterprise grade edge computing in seconds</div>

                                    </div>
                                    <div className="msg_box" style={ { display: "none" } }>
                                        <div className="common_msg success ">
                                            <div className="icon"></div>
                                            <div className="info">
                                                <strong>Success</strong><br></br>
                                                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                            </div>
                                        </div>
                                    </div>
                                    <div className="msg_box" style={ { display: "none" } }>
                                        <div className="common_msg error">
                                            <div className="icon"></div>
                                            <div className="info">Lorem Ipsum is simply dummy text of the print</div>
                                        </div>
                                    </div>

                                    <div className="box_inner_wrap">
                                        <div className="box-left">

                                            <div className="inp_row email">
                                                <label>Email</label>
                                                <input type="text" placeholder="name@company.com" autoFocus={ true } autoComplete="off" ref={ this.emailFocus } name="email" value={ this.state.email } className="txt-box" onChange={ (e) => this.handleInputs(e) } onBlur={ () => { this.userNameBlur(); } }></input>
                                                <i className="email_ico"></i>
                                                <span className="error_msg" style={ { display: this.state.emailEmpty ? "block" : "none" } }>Email cannot be blank</span>
                                                <span className="error_msg" style={ { display: this.state.emailValidation ? "block" : "none" } }>Email address is invalid</span>
                                                <span className="error_msg" style={ { display: this.state.emailExists ? "block" : "none" } }>Email already in use</span>
                                                <span className="error_msg" style={ { display: this.state.domainError ? "block" : "none" } }>Email address is invalid. Currently only Business email addresses are allowed.</span>
                                            </div>
                                            <div className="inp_row pswd">
                                                <label>Password
                                                    { this.state.passwordStrength === "" ? "" : this.state.passwordStrength === "Weak" ? <div className="pwd_strength weak">Weak</div> :
                                                        <div className="pwd_strength strong">Strong</div>
                                                    }
                                                </label>
                                                <div className="pwd_field_wrap">
                                                    <input type={ this.state.isPasswordShown ? "text" : "password" } placeholder="Create a Password" ref={ this.passwordFocus } name="password" value={ this.state.password } className="txt-box" onChange={ (e) => this.handleInputs(e) } onFocus={ this.getFocus } onClick={ this.getFocus } ></input>
                                                    <div className="id-tooltip id-tooltip-topright normal">
                                                        <p className="id-tooltip-note">Use atleast:</p>
                                                        <ul>
                                                            <li id="upperCaseLi">1 uppercase character</li>
                                                            <li id="lowerCaseLi">1 lowercase character</li>
                                                            <li id="numericLi">1 numerical digit</li>
                                                            <li id="specCharLi">1 special character</li>
                                                            <li id="eightCharLi">Min 8 characters</li>
                                                        </ul>
                                                    </div>
                                                    <i className="pswd_ico"></i>
                                                    <span className={ this.state.isPasswordShown ? "pwd_field_eyeIcon show_pwd" : "pwd_field_eyeIcon" } onClick={ () => { this.setState({ isPasswordShown: !this.state.isPasswordShown }); } } data-tip data-for="password"></span>
                                                    <ReactTooltip id="password" effect="solid" place="right">
                                                        { this.state.isPasswordShown ? "Hide" : "Show" }
                                                    </ReactTooltip>
                                                </div>
                                                <span className="error_msg" style={ { display: this.state.passwordEmpty ? "block" : "none" } }>Password cannot be blank</span>
                                                <span className="error_msg" style={ { display: this.state.passwordValidation ? "block" : "none" } }>Password must meet the criteria</span>
                                            </div>
                                            {/* </div> */ }

                                            {/*<div className="captcha_wrap">
                                <div className="g-recaptcha" data-sitekey="your_site_key"></div>
                            </div>*/}
                                            <div className="footer_wrap">
                                                {/*<input type="submit" name="" value="Update" className="btn-primary btnLoader"></input>*/ }

                                                <div className="btn_wrap"><input type="submit" value="Create Account" className="btn-primary submit_btn" ></input></div>
                                                <p className="business_email_text" style={ { display: "" } }>For non-business email addresses, there may be an ID verification process.</p>
                                                <p className="business_email_text" style={ { display: "none" } }>Available for customers with a valid business domain email address only.</p>
                                            </div>
                                        </div>
                                        <div className="box-middle">
                                            <div className="other_option_wrap"> Or </div>
                                        </div>
                                        <div className="box-right">
                                            <GoogleLogin
                                                clientId="537979516794-mcln2pq1tg3b01rq473co7g3suu62bl7.apps.googleusercontent.com"
                                                buttonText="Sign Up with Google"
                                                onSuccess={ (e) => this.handleGoogleSignUpSuccess(e) }
                                                onFailure={ (e) => this.handleGoogleSignUpFailure(e) }
                                                cookiePolicy={ 'single_host_origin' }
                                                prompt={ 'consent' }
                                                // uxMode={'redirect'}
                                                // redirectUri="http://localhost:3000"
                                                render={ renderProps => (
                                                    <div tabIndex="0" className="google_btn-primary" onClick={ (e) => { renderProps.onClick(); this.resetToDefault(); } } onKeyPress={ () => this.triggerClick('google') } disabled={ renderProps.disabled } id="googleBtn">
                                                        <span className="icon">
                                                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 48 48" className="abcRioButtonSvg">
                                                                <g>
                                                                    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                                                                    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                                                                    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                                                                    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                                                                    <path fill="none" d="M0 0h48v48H0z"></path>
                                                                </g>
                                                            </svg>
                                                        </span>
                                                        <span className="signin_content">Sign up with Google</span>
                                                    </div>
                                                ) }
                                            >
                                                <span> Sign up with Google</span>
                                            </GoogleLogin>
                                            <div tabIndex="0" className="github-btn-primary" onClick={ e => this.onGithubBtnClick(e) } onKeyPress={ () => this.triggerClick('github') } id="githubBtn">
                                                <span className="icon">
                                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 30 30" className="abcRioButtonSvg">
                                                        <path d="M15,0.3C6.8,0.3,0.1,7,0.1,15.2c0,7,4.8,12.8,11.3,14.5c-0.1-0.2-0.1-0.4-0.1-0.7v-2.5c-0.6,0-1.6,0-1.9,0
                      c-1,0-1.9-0.4-2.4-1.3c-0.5-0.9-0.6-2.3-1.8-3.1c-0.4-0.3-0.1-0.6,0.3-0.6c0.8,0.2,1.4,0.7,2,1.5c0.6,0.8,0.9,1,2,1
                      c0.5,0,1.3,0,2.1-0.2c0.4-1,1.1-2,2-2.4c-5-0.5-7.3-3-7.3-6.3c0-1.4,0.6-2.8,1.7-4C7.6,9.8,7.2,7.4,8.1,6.5c2.2,0,3.6,1.4,3.9,1.8
                      c1.1-0.4,2.3-0.6,3.6-0.6c1.3,0,2.5,0.2,3.6,0.6c0.3-0.4,1.7-1.8,3.9-1.8c0.9,0.9,0.5,3.3,0.1,4.5c1,1.2,1.7,2.6,1.7,4
                      c0,3.4-2.4,5.8-7.3,6.3c1.4,0.7,2.4,2.7,2.4,4.2V29c0,0.1,0,0.2,0,0.3c5.8-2,10-7.6,10-14.1C29.9,7,23.2,0.3,15,0.3z"></path>
                                                    </svg>
                                                </span>
                                                <span className="signin_content">Sign up with GitHub</span>
                                            </div>

                                        </div>

                                        {/* </div> */ }

                                        {/* <div className="other_option_wrap"> Or </div>
                            <div className="google_btn-primary">
                            <span className="icon">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 48 48" className="abcRioButtonSvg">
                            <g>
                            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                            <path fill="none" d="M0 0h48v48H0z"></path>
                            </g>
                            </svg>
                            </span>
                            <span className="signin_content">Sign up with Google</span>
                            </div>
                            <div className="github-btn-primary">
                            <span className="icon">
                            <svg x="0px" y="0px" width="30px" height="30px" viewBox="0 0 30 30" xmlSpace="preserve">
                            <path d="M15,0.3C6.8,0.3,0.1,7,0.1,15.2c0,7,4.8,12.8,11.3,14.5c-0.1-0.2-0.1-0.4-0.1-0.7v-2.5c-0.6,0-1.6,0-1.9,0
                                                c-1,0-1.9-0.4-2.4-1.3c-0.5-0.9-0.6-2.3-1.8-3.1c-0.4-0.3-0.1-0.6,0.3-0.6c0.8,0.2,1.4,0.7,2,1.5c0.6,0.8,0.9,1,2,1
                                                c0.5,0,1.3,0,2.1-0.2c0.4-1,1.1-2,2-2.4c-5-0.5-7.3-3-7.3-6.3c0-1.4,0.6-2.8,1.7-4C7.6,9.8,7.2,7.4,8.1,6.5c2.2,0,3.6,1.4,3.9,1.8
                                                c1.1-0.4,2.3-0.6,3.6-0.6c1.3,0,2.5,0.2,3.6,0.6c0.3-0.4,1.7-1.8,3.9-1.8c0.9,0.9,0.5,3.3,0.1,4.5c1,1.2,1.7,2.6,1.7,4
                                                c0,3.4-2.4,5.8-7.3,6.3c1.4,0.7,2.4,2.7,2.4,4.2V29c0,0.1,0,0.2,0,0.3c5.8-2,10-7.6,10-14.1C29.9,7,23.2,0.3,15,0.3z" />
                            </svg>
                            </span>
                            <span className="signin_content">Sign up with GitHub</span>
                            </div>                        */}
                                    </div >

                                    <div className="trust_device_option" style={ { display: "none" } }>
                                        <div className="checkbox_wrap">
                                            <input type="button" id="recaptchaButton" className="rpcRecaptchaBtn g-recaptcha" style={ { display: "none" } } data-sitekey="6LfvAiwUAAAAANov16A_dcQhR952_39cma0Itaof" data-callback="loginOnCaptchaVerify" data-badge="bottomright" data-size="invisible"></input>
                                            <input type="checkbox" name="" value="" id="trust_device" className="checkbox_option"></input>
                                            <label htmlFor="trust_device">Trust this device for 60 days?</label>
                                        </div>
                                    </div>
                                    <div className="signin_lnk">Already a member? <a href="https://www.idrivecompute.com/app/login">Sign in</a> </div>
                                </form >
                            </div >
                        </div >
                        <p className="sinup_note" style={ { display: this.state.isMsgShow ? "" : "none" } }>Available for customers with a valid business domain email address only</p>
                    </div >

                </div >
                <Footer />
                <CommonMessage message={ this.state.message } handler={ () => this.setState({ message: '' }) }
                    msgType={ this.state.msgType } />
                <div className="captcha">
                    <ReCAPTCHA
                        sitekey="6LfMaG8aAAAAADtCmgI91y-9wbCjnaDTQwwIUv6-"
                        onChange={ (e) => this.onRecaptchaChange(e) }
                        ref={ this.recaptchaRef }
                        size="invisible"
                    />
                </div>

            </main >
        );
    }
}
